var _path, _path2, _ellipse, _ellipse2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1625,
    height: 270,
    viewBox: "0 0 1625 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1194.63 27.5268C1193.93 23.7385 1197.3 26.6981 1198.56 18.2928C1199.65 10.998 1194.41 4.16834 1186.86 3.03825C1179.3 1.90815 1172.3 6.90559 1171.2 14.2003C1170.11 21.4951 1173.7 21.9399 1173.5 24.3644C1173.24 27.3579 1167.1 24.6351 1165.48 35.4419C1163.69 47.4494 1176.37 53.4955 1188.02 54.7721C1199.83 56.0676 1208.65 52.9095 1213.97 42.6967C1215.76 39.2804 1216.78 32.4317 1214.53 30.5031C1212.99 29.1924 1209.47 28.0333 1205.82 29.2009C1202.82 30.1643 1199.33 32.137 1196.76 30.3003C1195.64 29.4979 1194.85 28.6747 1194.63 27.5268Z",
    fill: "#FFDD38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.88 12.9291C1163.5 15.3843 1171.14 20.7539 1174.96 19.9904C1177.66 19.4505 1179.97 17.3543 1178.31 14.8835C1176.94 12.846 1174.55 12.8606 1172.07 12.4535C1169.51 12.0347 1167.3 11.4561 1165.88 12.9291Z",
    fill: "#FF7E1F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.67506,
    ry: 3.42403,
    transform: "matrix(0.847663 0.530536 -0.552476 0.833529 1181.99 11.2176)",
    fill: "#030303"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14027,
    ry: 1.72189,
    transform: "matrix(0.789483 0.613773 -0.637397 0.770535 1181.5 10.0262)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.69 36.2819C1185.88 35.4354 1182.61 30.9658 1178.67 33.0199C1174.19 35.3564 1177.12 40.7338 1180.69 44.2999C1185.91 49.514 1197.23 50.4921 1201.4 45.203C1203.42 42.6399 1204.84 40.0046 1202.58 37.3287C1199.9 34.1569 1195.29 37.0907 1190.69 36.2819Z",
    fill: "#FCE95F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M821.629 86.4409C1128.37 4.85919 1485.02 52.4485 1625 86.4409V270H-0.00012207V21C146.067 54.9924 514.888 168.023 821.629 86.4409Z",
    fill: "#95F2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveBackground);
export default __webpack_public_path__ + "static/media/wave-background.f0150d4a9e39960903e3dc69e685d33b.svg";
export { ForwardRef as ReactComponent };